export default {"src":"/_next/static/media/ccpa.783b3784.svg","height":14,"width":30,"blurWidth":0,"blurHeight":0};